import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Phone, Building2, Calendar } from 'lucide-react';
import { cn } from '@/lib/utils';

const items = [
  { name: 'Yfirlit', href: '/', icon: Home },
  { name: 'Leads', href: '/leads', icon: Users },
  { name: 'Símtöl', href: '/calls', icon: Phone },
  { name: 'Eignir', href: '/properties', icon: Building2 },
  { name: 'Skoðanir', href: '/viewings', icon: Calendar },
];

export default function BottomNav() {
  const location = useLocation();

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-gray-200 bg-white/95 backdrop-blur">
      <div className="flex items-center justify-around px-2 pt-2 pb-[calc(env(safe-area-inset-bottom)+0.5rem)]">
        {items.map((item) => {
          const isActive = location.pathname === item.href ||
            (item.href !== '/' && location.pathname.startsWith(item.href));

          return (
            <Link
              key={item.name}
              to={item.href}
              aria-label={item.name}
              className={cn(
                'flex flex-col items-center gap-1 rounded-lg px-3 py-2 min-h-[44px] text-xs font-medium transition-colors',
                isActive ? 'text-prima-700' : 'text-gray-500'
              )}
            >
              <item.icon className={cn('h-5 w-5', isActive ? 'text-prima-600' : 'text-gray-400')} />
              <span className="sr-only">{item.name}</span>
              <div className={cn('h-1 w-1 rounded-full', isActive ? 'bg-prima-600' : 'bg-transparent')} />
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
